import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, CircleQuestionMark } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FinalCallToAction() {
  return <section data-section-id="252647" id="צרו-קשר" className="bg-primary text-primary-foreground py-20 lg:py-32">
      <div className="page-container flex flex-col items-center text-center">
        <div className="max-w-3xl space-y-8">
          <div className="space-y-4">
            <h2 className="font-default text-3xl md:text-4xl lg:text-[var(--font-size-h2)] font-bold leading-tight">
              זקוקים למטפל סיעודי מקצועי באופן מיידי?
            </h2>
            <p className="font-default text-lg md:text-[var(--font-size-body)] text-primary-foreground/90 max-w-2xl mx-auto">
              אנחנו כאן כדי לספק לכם מענה מהיר, אנושי ומקצועי תוך 5 שעות בלבד. 
              השאירו פרטים עכשיו ונתאים לכם את המטפל הנכון ביותר עבור יקירכם.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-secondary text-secondary-foreground hover:opacity-90 shadow-md rounded-lg">
              <Link to="/ContactPage">
                <SafeHydrate><Calendar className="ml-2 size-5" /></SafeHydrate>
                תיאום מטפל עכשיו
              </Link>
            </Button>
            
            <Button asChild variant="secondary" size="lg" className="w-full sm:w-auto text-base h-12 px-8 bg-background/10 text-primary-foreground border border-primary-foreground/20 hover:bg-background/20 shadow-md rounded-lg">
              <Link to="/ProfessionalBlogPage">
                <CircleQuestionMark className="ml-2 size-5" />
                איך בוחרים מטפל מתאים?
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}